import Switch from '@ben/orion/switch';
import { Controller, useFormContext } from 'react-hook-form';

interface FallbackRankSwitchesProps {
  componentControllerName: string;
}

const FALLBACK_RANK_CONFIG = [
  {
    field: 'fallbackToHighestEligibleOptionRank' as const,
    oppositeField: 'fallbackToLowestEligibleOptionRank' as const,
    label: 'Fallback to highest eligible option rank',
    hintText:
      'If enabled, the highest eligible option rank will be used as the fallback value when the selected option is not eligible based on the option eligibility rule.',
  },
  {
    field: 'fallbackToLowestEligibleOptionRank' as const,
    oppositeField: 'fallbackToHighestEligibleOptionRank' as const,
    label: 'Fallback to lowest eligible option rank',
    hintText:
      'If enabled, the lowest eligible option rank will be used as the fallback value when the selected option is not eligible based on the option eligibility rule.',
  },
] as const;

const FallbackRankSwitches = ({
  componentControllerName,
}: FallbackRankSwitchesProps) => {
  const { control, setValue } = useFormContext();

  return (
    <>
      {FALLBACK_RANK_CONFIG.map(({ field, oppositeField, label, hintText }) => (
        <Controller
          key={field}
          name={`${componentControllerName}.${field}`}
          control={control}
          render={({ field: controllerField }) => (
            <Switch
              {...controllerField}
              label={label}
              defaultValue={controllerField.value}
              onChange={(checked) => {
                controllerField.onChange(checked);
                if (checked) {
                  setValue(
                    `${componentControllerName}.${oppositeField}`,
                    false
                  );
                }
              }}
              hintText={hintText}
            />
          )}
        />
      ))}
    </>
  );
};

export default FallbackRankSwitches;
